"use server";
import "server-only";

import { getPremiumClient, AxiosResponseDataType } from "../../axios/api";
import axios from "axios";
import { cookies } from "next/headers";

export interface FormState {
  errors?: {
    path: string;
    message: string;
  }[];
  success?: boolean;
  message?: string;
}

type FormResDataType = AxiosResponseDataType<{
  accessToken: string;
  refreshToken: string;
}>;

type FormType = "login" | "signup";
type GetFormActionProps = {
  pathname: string;
  formType: FormType;
};

function normalizePath(url: string): string {
  try {
    // Absolute URL
    const newUrl = new URL(url);
    return newUrl.pathname;
  } catch {
    // Probably already a path
    if (url.startsWith("/")) {
      return url;
    }

    throw new Error(`Invalid pathname or URL: ${url}`);
  }
}

export async function createFormAction({
  pathname,
  formType,
}: GetFormActionProps) {
  const uriPathname = normalizePath(pathname);

  return async function formAction(
    _state: FormState,
    formData: FormData
  ): Promise<FormState> {
    "use server";
    const _client = await getPremiumClient();

    try {
      const { data } = await _client.post<FormResDataType>(uriPathname, {
        formData,
      });

      const tokens = data.data;

      if (!tokens?.accessToken || !tokens.refreshToken) {
        throw new Error(
          `Invalid ${formType} response: accessToken or refreshToken missing`
        );
      }

      const cookieStore = await cookies();
      cookieStore.set("accessToken", tokens.accessToken);
      cookieStore.set("refreshToken", tokens.refreshToken);

      return {
        success: true,
        message: `${formType} successful`,
      };
    } catch (err) {
      if (axios.isAxiosError(err)) {
        const message =
          err.response?.data?.message ??
          err.message ??
          `${formType} request failed`;

        throw new Error(`${message} (${formType} submission)`);
      }

      throw err instanceof Error
        ? err
        : new Error("Unexpected error during " + formType);
    }
  };
}
